import { createSlice } from "@reduxjs/toolkit";
import { kullaniciRolYetkiApi } from "src/services/Auth/KullaniciRolYetkiApi";

export class ControlAuth {
    authCode: string;
    authVal: number;
    modulId: number;
}

export interface ControlAuthState {
    data: Array<ControlAuth>;
}

const ControlAuthSlice = createSlice<ControlAuthState, {}>({
    name: 'ControlAuthSlice',
    initialState: {
        data: []
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder.addMatcher(kullaniciRolYetkiApi.endpoints.getVwKullaniciKontrolyetki.matchFulfilled, (state, action) => {
            return {
                ...state,
                data: action.payload.map(m => {
                    return {
                        authCode: m.yetkikodu,
                        authVal: m.yetkili == "E" ? 1 : 0,
                        modulId: m.fkGnlModulId
                    }
                })
            }
        })
    }
})
export default ControlAuthSlice;